import { AbstractPerson } from 'fobclient/lib/entity'
import PersonIdent from '@/schema/PersonIdent'

export default {
  label: 'Externe Person',
  route: 'abstractperson',
  class: AbstractPerson,
  className: 'abstractPerson',
  preliminaryStringRep (data) {
    return `${data.vorname} ${data.name}`
  },
  tableSelectColumns: [
    {
      label: '_id',
      field: '_id'
    },
    {
      label: '_stringRep',
      field: '_stringRep'
    }
  ],
  fields: [
    {
      label: 'AbstractPerson.form.vorname',
      field: 'vorname',
      type: 'string'
    },
    {
      label: 'AbstractPerson.form.nachname',
      field: 'name',
      type: 'string'
    },
    PersonIdent
  ]
}



// WEBPACK FOOTER //
// ./src/schema/AbstractPerson.js